module.exports = __webpack_public_path__ + "media/images/chat_preview_landscape-ea9581ff5c9658d13d6e94076f3e1a47.png";